module.exports = __webpack_public_path__ + "img/2_175.bab3dfbb.png";